import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { useApi } from 'services/api';
import { parseQueryString } from 'utils/url';
import { getConfiguredTimezone } from 'utils/datetime';

const useGroupTimeline = (groupId) => {
  const api = useApi();
  const location = useLocation();
  const query = parseQueryString(location.search);
  const timezone = getConfiguredTimezone();

  return useQuery({
    queryKey: ['groupTimeline', groupId],
    queryFn: () => {
      const [day, typeId, sensorId] = groupId.split('-');

      return api.get('/search/query', {
        params: {
          query: `${day} acknowledged=${query.ack || 0} typeId=${typeId} ${
            +sensorId === 0 ? '' : `sensorId=${sensorId}`
          } | include createdAt, id, displayText`,
          context: [],
          searchType: 'O_NOTIFICATIONS',
          timezone,
        },
      });
    },
    enabled: !!groupId,
  });
};

export default useGroupTimeline;
